import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { useState } from 'react';
import useDebounceFn from './useDebounceFn';

function useDebounce(value, wait) {
  var _useState = useState(value),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  useDebounceFn(function () {
    setState(value);
  }, [value], wait);
  return state;
}

export default useDebounce;